import React from 'react';
import styled from 'styled-components';
import {
  screenMdMin,
  spacer,
  desktopFinaleBold,
  desktopMestoBold,
} from '@spotify-internal/encore-web-v6';
import { useT } from '@spotify-internal/i18n-core';
import { TRACK_CAT } from '../constants';
import {
  FooterTextLinkType,
  FooterTextLink,
} from '../components/FooterTextLink';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacer.spacer16};
  @media (min-width: ${screenMdMin}) {
    gap: ${spacer.spacer32};
  }
`;

const StyledPolicyLink = styled(FooterTextLink)`
  font-size: ${desktopFinaleBold.fontSize} !important;
  font-family: ${desktopFinaleBold.fontFamily} !important;
  font-weight: ${desktopFinaleBold.fontWeight} !important;
  @media (min-width: ${screenMdMin}) {
    font-size: ${desktopMestoBold.fontSize} !important;
    font-family: ${desktopMestoBold.fontFamily} !important;
    font-weight: ${desktopMestoBold.fontWeight} !important;
  }
`;

type PolicyLink = FooterTextLinkType & { label: string };

export function Policies() {
  const t = useT();

  const links: PolicyLink[] = [
    {
      label: t(
        'FRODOR_LEGAL_LINK_TEXT_FOOTER',
        'Legal',
        'Legal refers to terms and conditions',
      ),
      href: 'https://www.spotify.com/legal/spotify-for-artists-terms-and-conditions/',
      dataTestId: 'footer-legal',
      track: [TRACK_CAT, 'Legal'],
      external: true,
    },
    {
      label: t(
        'FRODOR_PRIVACY_LINK_TEXT_FOOTER',
        'Privacy',
        'Refers to the privacy policy',
      ),
      href: 'https://www.spotify.com/legal/privacy-policy/',
      dataTestId: 'footer-privacy',
      track: [TRACK_CAT, 'Privacy Policy'],
      external: true,
    },
    {
      label: t(
        'FRODOR_COOKIES_LINK_TEXT_FOOTER',
        'Cookies',
        'Cookies are a user tracking method for the web',
      ),
      href: 'https://www.spotify.com/legal/cookies-policy/',
      dataTestId: 'footer-cookies',
      track: [TRACK_CAT, 'Cookies'],
      external: true,
    },
  ];

  return (
    <Container>
      {links.map(link => {
        return (
          <StyledPolicyLink key={link.label} {...link}>
            {link.label}
          </StyledPolicyLink>
        );
      })}
    </Container>
  );
}
